// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.plasma-wallet",
    name: "Plasma Wallet",
    homepage: "https://plasma-wallet.com",
    image_id: "c268e78d-ffb0-4c8b-5cad-04c3add48500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/plasmapay-defi-crypto-wallet/id1461735396",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "plasmawallet://",
        universal: "https://plasma-wallet.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map